import React from "react";

const TypingIndicator = () => {
  return (
    <div className="mb-4 flex justify-start">
      <div className="rounded-25px bg-grey-18 px-4.5 py-2.5">
        <div className="flex items-center gap-2.5">
          <div className="size-2 animate-bounce rounded-full bg-grey-14 [animation-delay:-0.3s]"></div>
          <div className="size-2 animate-bounce rounded-full bg-grey-14 [animation-delay:-0.15s]"></div>
          <div className="size-2 animate-bounce rounded-full bg-grey-14"></div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
